module.exports = __webpack_public_path__ + "img/27ne.fca3ece1.svg";